export default "__VITE_ASSET__adac39db__"